import axiosInstance from '../utils/AxiosConfig';

export const getSuppliers = async (
  page = 1,
  pageSize = 10,
  searchTerm = '',
  options = {}
) => {
  const {
    sortField,
    sortDirection,
    filterField,
    filterOperator,
    filterValue,
    skipGlobalErrorRedirect = false
  } = options;

  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString()
  });
  
  // Agregar search solo si hay contenido
  if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
    params.append('search', searchTerm.trim());
  }

  if (sortField) {
    params.append('sortField', sortField);
  }

  if (sortDirection) {
    params.append('sortDirection', sortDirection);
  }

  if (filterField) {
    params.append('filterField', filterField);
  }

  if (filterOperator) {
    params.append('filterOperator', filterOperator);
  }

  if (filterValue !== undefined && filterValue !== null && String(filterValue).trim() !== '') {
    params.append('filterValue', String(filterValue).trim());
  }
  
  const response = await axiosInstance.get(`/providers?${params}`, { skipGlobalErrorRedirect });
  return response.data.data;
};

export const createSupplier = async (provider) => {
  const response = await axiosInstance.post(`/providers`, provider);
  return response.data.data;
};

export const updateSupplier = async (id, provider) => {
  const response = await axiosInstance.put(`/providers/${id}`, provider);
  return response.data.data;
};

export const deleteSupplier = async (id) => {
  await axiosInstance.delete(`/providers/${id}`);
};
